import GeneratedContactStore from "./generated/GeneratedContactStore"

class ContactStore extends GeneratedContactStore {

}

export const contactStore = new ContactStore()
